// The Catholic University of America's undergraduate majors (#2840). Read on
// 2026-10-01 from the official 2026-2027 Undergraduate Announcements, Bachelor
// Degree Programs list. The catalog is hosted on catholic.smartcatalogiq.com,
// so every group cites the .edu Academic Announcements page
// (enrollment-services.catholic.edu) that links it. The list is flat; each
// major sits under the school its own catalog page names ("This major is
// offered through ..."). Where that page names none, the school's own
// catalog section was used: Architecture and the joint Architecture and
// Civil Engineering degree (Architecture and Allied Arts, Programs of
// Studies), Biomedical, Electrical and Mechanical Engineering (Engineering,
// Physics, and Computing departments), Business Administration (Busch,
// Major Programs), Business (B.A.Mgt.) and Information Technology
// (Professional Studies, Bachelor's Degrees), the Philosophy degrees
// (Philosophy, Programs of Study), and Drama (B.A.) with the Department of
// Drama's other majors in the Rome School. Joint degrees sit under the
// first-named school. Left out: "Business - Secondary Major Only" (a second
// major only), "Social Sciences" (B.A.I.S., "currently closed to new
// students"), "Philosophy, Second Bachelor of Philosophy" (a second
// degree) and "Nursing, Accelerated" (the Apply page lists the ABSN under
// Post-Baccalaureate admission). Degree abbreviations are the
// catalog's own. The audition flag quotes the Rome School admission page
// (the college file's `arts` source). The KB's majors list was the starting
// point; the catalog wins.
const majors = {
    "slug": "the-catholic-university-of-america",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Catholic University's 2026-2027 Undergraduate Announcements, grouped by the school that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "School of Architecture and Allied Arts",
            "source": {
                "label": "Catholic University 2026-2027 Undergraduate Announcements, Bachelor Degree Programs (linked from Academic Announcements)",
                "url": "https://enrollment-services.catholic.edu/announcements/index.html"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.S.Arch."
                },
                {
                    "name": "Architecture and Civil Engineering",
                    "degree": "B.S.Arch. and B.C.E."
                },
                {
                    "name": "Architectural Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Art & Design",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Catholic University 2026-2027 Undergraduate Announcements, Bachelor Degree Programs (linked from Academic Announcements)",
                "url": "https://enrollment-services.catholic.edu/announcements/index.html"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Archaeology",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Classical Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Criminology",
                    "degree": "B.A."
                },
                {
                    "name": "Education Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematical Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics and Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics and Secondary Education",
                    "degree": "B.S."
                },
                {
                    "name": "Media and Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Medieval and Byzantine Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Politics",
                    "degree": "B.A."
                },
                {
                    "name": "Psychological and Brain Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish for International Service",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Rome School of Performing Arts (College of Arts and Sciences)",
            "source": {
                "label": "Catholic University 2026-2027 Undergraduate Announcements, Bachelor Degree Programs (linked from Academic Announcements)",
                "url": "https://enrollment-services.catholic.edu/announcements/index.html"
            },
            "majors": [
                {
                    "name": "Acting for Theatre, Film, and Television",
                    "degree": "B.F.A.",
                    "flag": "Most Rome School programs also require a successful audition.",
                    "flagSource": "arts"
                },
                {
                    "name": "Drama",
                    "degree": "B.A.",
                    "flag": "Most Rome School programs also require a successful audition.",
                    "flagSource": "arts"
                },
                {
                    "name": "Music",
                    "degree": "B.A.",
                    "flag": "Most Rome School programs also require a successful audition.",
                    "flagSource": "arts"
                },
                {
                    "name": "Music",
                    "degree": "B.M.",
                    "flag": "Most Rome School programs also require a successful audition.",
                    "flagSource": "arts"
                },
                {
                    "name": "Musical Theatre",
                    "degree": "B.F.A.",
                    "flag": "Most Rome School programs also require a successful audition.",
                    "flagSource": "arts"
                },
                {
                    "name": "Music and Business Administration",
                    "degree": "B.A. and B.S.B.A."
                }
            ]
        },
        {
            "name": "The Tim and Steph Busch School of Business",
            "source": {
                "label": "Catholic University 2026-2027 Undergraduate Announcements, Bachelor Degree Programs (linked from Academic Announcements)",
                "url": "https://enrollment-services.catholic.edu/announcements/index.html"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "International Economics and Finance",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Engineering, Physics, and Computing",
            "source": {
                "label": "Catholic University 2026-2027 Undergraduate Announcements, Bachelor Degree Programs (linked from Academic Announcements)",
                "url": "https://enrollment-services.catholic.edu/announcements/index.html"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.B.E."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.C.E."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S.C.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.E.E."
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "B.E.C.E."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.M.E."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Conway School of Nursing",
            "source": {
                "label": "Catholic University 2026-2027 Undergraduate Announcements, Bachelor Degree Programs (linked from Academic Announcements)",
                "url": "https://enrollment-services.catholic.edu/announcements/index.html"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                }
            ]
        },
        {
            "name": "School of Philosophy",
            "source": {
                "label": "Catholic University 2026-2027 Undergraduate Announcements, Bachelor Degree Programs (linked from Academic Announcements)",
                "url": "https://enrollment-services.catholic.edu/announcements/index.html"
            },
            "majors": [
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "Ph.B."
                },
                {
                    "name": "Philosophy Pre-Law",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy, Scholar's Program",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy Pre-Law, Scholar's Program",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "National Catholic School of Social Service",
            "source": {
                "label": "Catholic University 2026-2027 Undergraduate Announcements, Bachelor Degree Programs (linked from Academic Announcements)",
                "url": "https://enrollment-services.catholic.edu/announcements/index.html"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        },
        {
            "name": "School of Theology and Religious Studies",
            "source": {
                "label": "Catholic University 2026-2027 Undergraduate Announcements, Bachelor Degree Programs (linked from Academic Announcements)",
                "url": "https://enrollment-services.catholic.edu/announcements/index.html"
            },
            "majors": [
                {
                    "name": "Theology and Religious Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Professional Studies",
            "source": {
                "label": "Catholic University 2026-2027 Undergraduate Announcements, Bachelor Degree Programs (linked from Academic Announcements)",
                "url": "https://enrollment-services.catholic.edu/announcements/index.html"
            },
            "majors": [
                {
                    "name": "Business",
                    "degree": "B.A.Mgt."
                },
                {
                    "name": "Cybersecurity",
                    "degree": "B.S."
                },
                {
                    "name": "Human Services Administration",
                    "degree": "B.A."
                },
                {
                    "name": "Information Technology",
                    "degree": "B.A.I.T."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.A.I.S."
                }
            ]
        }
    ]
};

export default majors;
